<script>
export default {
    name: "AvatarUploaderComponent",

    props: ['avatar'],

    mounted() {

        if(this.avatar) {
            console.log('avatar exists');
            this.previewImage = this.avatar;
        }
    },

    data() {
        return {
            previewImage: null
        };
    },

    methods: {
        selectImage() {
            this.$refs.fileInput.click()
        },

        pickFile () {
            let input = this.$refs.fileInput
            let file = input.files

            if (file && file[0]) {
                let reader = new FileReader

                reader.onload = e => {
                    this.previewImage = e.target.result
                }

                reader.readAsDataURL(file[0])

                this.$emit('input', file[0])
            }
        }
    }
}
</script>
